import React from 'react';

function PrivacyPolicy() {
    return (
        <div className="page">
            <header className="page-header">
                <span className="page-eyebrow">Legal</span>
                <h1>Privacy Policy</h1>
                <p className="page-subtitle">Effective date: May 11, 2026</p>
            </header>

            <section className="panel">
                <p>
                    This Privacy Policy explains how RecipeCore.net ("RecipeCore", "we", "us", "our") collects, uses,
                    stores, and shares personal data when you use our website and services.
                </p>
                <p>
                    Data controller contact: Douwe Hummeling, Liemarstrasse 25, 48691 Vreden, Germany.
                    Privacy contact: support@pollarity.app.
                </p>
            </section>

            <section className="panel">
                <h2>1. Data we collect</h2>
                <ul>
                    <li>Account data: email address, encrypted password hash, account creation date.</li>
                    <li>User content: saved recipes, recipe notes, source URLs, and tags.</li>
                    <li>Billing and payments: Stripe customer ID and payment status metadata.</li>
                    <li>Referral data: referral code used, creator attribution, and payout-related records.</li>
                    <li>Advertising data: ad consent preference and ad event telemetry (such as impressions and clicks).</li>
                    <li>Security and operations data: technical request logs needed for reliability and abuse prevention.</li>
                </ul>
            </section>

            <section className="panel">
                <h2>2. How we use data</h2>
                <ul>
                    <li>To provide account access, saved recipes, and core application features.</li>
                    <li>To process one-time ad-removal payments and related payout/accounting workflows.</li>
                    <li>To operate referral discounts and creator payout tracking.</li>
                    <li>To provide ad-consent controls and ad-related operational analytics.</li>
                    <li>To protect the service, enforce terms, and investigate abuse or fraud.</li>
                </ul>
            </section>

            <section className="panel">
                <h2>3. Third-party services and processors</h2>
                <p>We use external providers to run the service, including:</p>
                <ul>
                    <li>Google Firebase / Google Cloud (hosting, server runtime, and related infrastructure).</li>
                    <li>MongoDB (database storage).</li>
                    <li>Stripe (payment processing).</li>
                    <li>Monetag (advertising delivery).</li>
                </ul>
            </section>

            <section className="panel">
                <h2>4. Cookies and similar technologies</h2>
                <ul>
                    <li>Authentication cookies are used to keep users signed in securely.</li>
                    <li>Local/session storage is used for app preferences and workflow continuity.</li>
                    <li>Advertising-related technologies may be used by ad providers.</li>
                    <li>You can manage advertising consent in your account experience where available.</li>
                </ul>
            </section>

            <section className="panel">
                <h2>5. Data retention</h2>
                <ul>
                    <li>Account and recipe data is retained until the user deletes the account.</li>
                    <li>If an account is not deleted by the user, account records remain stored.</li>
                    <li>Payout and payout-ledger records are retained for 5 years, or until project shutdown.</li>
                </ul>
            </section>

            <section className="panel">
                <h2>6. Account deletion and data rights</h2>
                <p>
                    Users can request account-related privacy actions by contacting support@pollarity.app.
                    Users can also delete their account from within the application where this feature is available.
                </p>
            </section>

            <section className="panel">
                <h2>7. Security</h2>
                <p>
                    We use technical and organizational measures to protect data, including authenticated access controls,
                    password hashing, security headers, and rate limiting. No method of storage or transmission is 100% secure.
                </p>
            </section>

            <section className="panel">
                <h2>8. Changes to this policy</h2>
                <p>
                    If this Privacy Policy changes, a one-time in-app popup notice may be shown during a one-month window
                    following the change. Continued use after notice may be treated as acceptance of the updated policy.
                </p>
            </section>

            <section className="panel">
                <h2>9. Contact</h2>
                <p>
                    Questions about this Privacy Policy can be sent to support@pollarity.app.
                </p>
            </section>
        </div>
    );
}

export default PrivacyPolicy;
